import { render, staticRenderFns } from "./ModalWindowSize.vue?vue&type=template&id=c73fef1e&"
import script from "./ModalWindowSize.vue?vue&type=script&lang=js&"
export * from "./ModalWindowSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports